export const CHANNEL_MODELS_PERMISSION_TYPES = Object.freeze({
  ENABLED: true,
  DISABLED: false,
})